import { Box, Button, MenuItem, Select } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import { styled } from '@mui/material/styles';
import { TooltipCC } from 'components/common';
import TextFieldVMP from 'components/common/TextField/TextFieldVMP';
import moment from 'moment';
import * as React from 'react';
import { useEffect, useState } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from 'theme';
import { toastError } from 'utils/helpers';
import { DatePickerCustom } from '../components/DatePickerCustom/index';
import { setValue } from '../modelPeriodSlice';
import './modalPeriodDay.css';
import { daily, maxDateTime, monthly, weekly } from '../constants';
import { ChangeDay, ChangeWeek } from '../functions';
import { IconClose } from 'assets/icons';

const TextFieldVMPCC = styled(TextFieldVMP)({
    '& .MuiOutlinedInput-root': {
        width: '100%'
    }
})

export default function ModelPeriodDay({ open, handleClickOpen, handleClose, periodTime, typePeriod, isMain = true }) {
    const keyRef = React.useRef(Date.now());

    const { t } = useTranslation();

    const dataPeriod = useSelector((state) => state.modelPeriod);
    useEffect(() => {
        if (dataPeriod.time_profile_type_id && dataPeriod.start_time !== null) {
            setData((data) => ({ ...data, interval: dataPeriod.interval }));
            if (dataPeriod.time_profile_type_id === 1) {
            } else if (dataPeriod.time_profile_type_id === 2) {
                setSelectedDay(dataPeriod.day);
            } else if (dataPeriod.time_profile_type_id === 3) {
                if (dataPeriod.week) {
                    setValueMonth(2);
                    setSelectedWeek(dataPeriod.week);
                    setSelectedDayWeekMonth(dataPeriod.day);
                } else if (dataPeriod.day?.length === 1) {
                    setValueMonth(1);
                    setSelectedDayMonth(dataPeriod.day);
                    // setStartDate(new Date(year, month, dataPeriod.day[0]));
                }
            }
        }
        setData({ ...data, start_time: dataPeriod.start_time, end_time: dataPeriod.end_time });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataPeriod]);

    const dispatch = useDispatch();
    const repeat = [
        {
            value: 1,
            label: `${t('room.model-period.day')}`,
        },
        {
            value: 2,
            label: `${t('room.model-period.week')}`,
        },
        {
            value: 3,
            label: `${t('room.model-period.month')}`,
        },
    ];

    const days = [
        {
            name: t('room.desc-week.days.T2'),
            value: 1,
        },
        {
            name: t('room.desc-week.days.T3'),
            value: 2,
        },
        {
            name: t('room.desc-week.days.T4'),
            value: 3,
        },
        {
            name: t('room.desc-week.days.T5'),
            value: 4,
        },
        {
            name: t('room.desc-week.days.T6'),
            value: 5,
        },
        {
            name: t('room.desc-week.days.T7'),
            value: 6,
        },
        {
            name: t('room.desc-week.days.CN'),
            value: 7,
        },
    ];
    const [data, setData] = useState({
        time_profile_type_id: 1,
        start_time: dataPeriod.start_time ? dataPeriod.start_time : periodTime?.start,
        end_time: dataPeriod.end_time ? dataPeriod.end_time : periodTime?.end,
        interval: 1,
        day: null,
        week: null,
        min_end_time: dataPeriod.end_time ? dataPeriod.end_time : periodTime?.end
    });

    const [selectedDay, setSelectedDay] = useState([moment(periodTime.start).day()]);

    const [valueMonth, setValueMonth] = useState(1);

    const [selectedDayMonth, setSelectedDayMonth] = useState([new Date().getDate()]);

    const [selectedDayWeekMonth, setSelectedDayWeekMonth] = useState([1]);

    const [selectedWeek, setSelectedWeek] = useState(1);

    const dateRangeSearchRef = React.useRef();

    const [isClosed, setIsClosed] = useState(false);

    const [renderDatePicker, setRenderDatePicker] = useState(true);

    const handleChangeValueMonth = (value) => {
        setValueMonth(value);
    };

    const handleApplyTimePeriod = (event, picker) => {
        // setData((prev) => ({ ...prev, start_time: picker.startDate, end_time: picker.endDate }));
        setData((prev) => ({ ...prev, end_time: picker.startDate.startOf('day').add(14, 'hours') }));
    };

    const handleSubmit = () => {
        if (data.time_profile_type_id === 1) {
            dispatch(
                setValue({
                    time_profile_type_id: data.time_profile_type_id,
                    start_time: data.start_time,
                    end_time: data.end_time,
                    interval: data.interval,
                    day: null,
                    week: null,
                }),
            );
            handleClose();
        } else if (data.time_profile_type_id === 2) {
            if (selectedDay.length === 0) {
                toastError(t('toast.validateLoop'));
            } else {
                dispatch(
                    setValue({
                        time_profile_type_id: data.time_profile_type_id,
                        start_time: data.start_time,
                        end_time: data.end_time,
                        interval: data.interval,
                        day: selectedDay,
                        week: null,
                    }),
                );
                handleClose();
            }
        } else if (data.time_profile_type_id === 3) {
            if (valueMonth === 1) {
                dispatch(
                    setValue({
                        time_profile_type_id: data.time_profile_type_id,
                        start_time: data.start_time,
                        end_time: data.end_time,
                        interval: data.interval,
                        day: selectedDayMonth,
                        week: null,
                    }),
                );
                handleClose();
            } else {
                dispatch(
                    setValue({
                        time_profile_type_id: data.time_profile_type_id,
                        start_time: data.start_time,
                        end_time: data.end_time,
                        interval: data.interval,
                        day: selectedDayWeekMonth,
                        week: selectedWeek,
                    }),
                );
                handleClose();
            }
        }
    };

    useEffect(() => {
        setData((prev) => ({ ...prev, time_profile_type_id: typePeriod }));
    }, [typePeriod]);

    useEffect(() => {
        setRenderDatePicker(false);
        setTimeout(() => {
            setRenderDatePicker(true);
        }, 1);
    }, [data]);

    useEffect(() => {
        //all (daily, weekly, monthly)
        setData((prev) => ({ ...prev, interval: 1 }));
        setData((prev) => ({
            ...prev,
            start_time: periodTime?.start,
            end_time: periodTime?.end,
            min_end_time: (!(moment(dataPeriod.end_time).diff(moment(), 'days') < 0)) ? moment(periodTime.start).add(
                typePeriod === 1 ? 1 : typePeriod === 2 ? 1 : 1,
                typePeriod === 1 ? 'days' : typePeriod === 2 ? 'w' : 'M',
            ) : (
                moment(dataPeriod.end_time)
            ),
        }));

        //weekly
        let selectedDayWeek = moment(periodTime.start).day();
        if (selectedDayWeek === 0) {
            setSelectedDay([7]);
        } else {
            setSelectedDay([selectedDayWeek]);
        }

        //monthly
        // setStartDate(new Date(year, month, parseInt(moment(periodTime.start).format('DD'))));
        setSelectedDayMonth([parseInt(moment(periodTime.start).format('DD'))]);
        setSelectedDayWeekMonth([1]);
        setSelectedWeek(1);

        if (dataPeriod.time_profile_type_id === 1 && dataPeriod.time_profile_type_id === typePeriod) {
            setData((prev) => ({ ...prev, interval: dataPeriod.interval }));
        } else if (dataPeriod.time_profile_type_id === 2 && dataPeriod.time_profile_type_id === typePeriod) {
            setData((prev) => ({ ...prev, interval: dataPeriod.interval }));
            setSelectedDay(dataPeriod.day);
        } else if (dataPeriod.time_profile_type_id === 3 && dataPeriod.time_profile_type_id === typePeriod) {
            setData((prev) => ({ ...prev, interval: dataPeriod.interval }));
            if (dataPeriod.week) {
                setValueMonth(2);
                setSelectedDayWeekMonth(dataPeriod.day);
                setSelectedWeek(dataPeriod.week);
            } else {
                setValueMonth(1);
                setSelectedDayMonth(dataPeriod.day);
                // setStartDate(new Date(year, month, dataPeriod.day[0]));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [periodTime]);

    return (
        <div style={{ width: '490px' }}>
            <Dialog
                className="modalPeriodDay"
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle
                    id="customized-dialog-title"
                    onClose={() => {
                        setIsClosed(!isClosed);
                        handleClose();
                    }}
                    style={{ minWidth: '455px', fontSize: '1.5rem', fontWeight: '700', color: color.default}}
                >
                    {t('room.model-period.header')}
                    <TooltipCC title={t('room.close')}>
                        <IconButton
                            aria-label="close"
                            onClick={() => {
                                setIsClosed(!isClosed);
                                handleClose();
                            }}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <IconClose />
                        </IconButton>
                    </TooltipCC>
                </DialogTitle>
                <DialogContent dividers sx={{border: '0px !important'}}>
                    <div className="row" style={{display: 'flex', width: '100%'}}>
                        <div className="col-md-4" style={{flex: '0 0 auto', width: '33.33333333%', color: color.default}}>{t('room.model-period.title1')}</div>
                        <div className="col-md-8" style={{flex: '1 0 auto', width: '66.66666667%%'}}>
                            {renderDatePicker && (data?.end_time || data.time_profile_type_id) && (
                                <div style={{ position: 'relative' }}>
                                    <TooltipCC title={t('room.calendar-img')}>
                                        <img
                                            id={'icon-date-1'}
                                            className={'icon-calender-right'}
                                            src={require('../../../assets/img/icon-calendar.svg').default}
                                            alt=""
                                            style={{ position: 'absolute', top: '6px', right: '5px' }}
                                            onClick={() => {
                                                document.getElementById('date-1').click();
                                            }}
                                        />
                                    </TooltipCC>
                                    <DateRangePicker
                                        ref={dateRangeSearchRef}
                                        key={keyRef.current}
                                        initialSettings={{
                                            autoApply: true,
                                            singleDatePicker: true,
                                            timePicker: false,
                                            showDropdowns: true,
                                            minDate: moment(data.min_end_time).toDate(),
                                            maxDate: moment(maxDateTime.dateMax),
                                            startDate: moment(data.end_time).toDate(),
                                            // endDate: moment(data.end_time).toDate(),
                                            locale: {
                                                format: 'DD/MM/YYYY',
                                                cancelLabel: t('filter.dateRange.cancel'),
                                                applyLabel: t('filter.dateRange.apply'),
                                                daysOfWeek: [
                                                    t('dateRangePicker.Su'),
                                                    t('dateRangePicker.Mo'),
                                                    t('dateRangePicker.Tu'),
                                                    t('dateRangePicker.We'),
                                                    t('dateRangePicker.Th'),
                                                    t('dateRangePicker.Fr'),
                                                    t('dateRangePicker.Sa'),
                                                ],
                                                monthNames: [
                                                    t('dateRangePicker.January'),
                                                    t('dateRangePicker.February'),
                                                    t('dateRangePicker.March'),
                                                    t('dateRangePicker.April'),
                                                    t('dateRangePicker.May'),
                                                    t('dateRangePicker.June'),
                                                    t('dateRangePicker.July'),
                                                    t('dateRangePicker.August'),
                                                    t('dateRangePicker.September'),
                                                    t('dateRangePicker.October'),
                                                    t('dateRangePicker.November'),
                                                    t('dateRangePicker.December'),
                                                ],
                                            },
                                        }}

                                        onHide={handleApplyTimePeriod}
                                    >
                                        <input
                                            id={'date-1'}
                                            type="text"
                                            className="form-control col input-form-focus date-picker-vmp"
                                            style={{
                                                width: '100%',
                                                padding: '0.5rem 0.75rem',
                                                // borderWidth: '1px',
                                                // borderColor: 'rgba(170, 170, 170, 0.67)',
                                                borderRadius: '4px',
                                                // outline: '1px'
                                            }}
                                            format="DD/MM/YYYY"
                                            onKeyPress={(event) => {
                                                if (event.key === 'Enter') event.preventDefault();
                                            }}
                                        />
                                    </DateRangePicker>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="row margin-top-row" style={{display: 'flex'}}>
                        <div className="col-md-4" style={{flex: '0 0 auto', width: '33.33333333%', color: color.default}}>{t('room.model-period.repeat')}</div>
                        <div className="col-md-8" style={{display: 'flex' ,flex: '1 0 auto', width: '66.66666667%%', justifyContent: 'space-between'}}>
                            <Box sx={{width: '49%'}}>
                                <TextFieldVMPCC
                                    id="select-repeat"
                                    type="number"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        inputProps: {
                                            min:
                                                data.time_profile_type_id === 1
                                                    ? daily.min
                                                    : data.time_profile_type_id === 2
                                                        ? weekly.min
                                                        : monthly.min,
                                            max:
                                                data.time_profile_type_id === 1
                                                    ? daily.max
                                                    : data.time_profile_type_id === 2
                                                        ? weekly.max
                                                        : monthly.max,
                                        },
                                    }}
                                    variant="outlined"
                                    size="small"
                                    value={
                                        data.time_profile_type_id === 2 && data.interval > weekly.max
                                            ? 13
                                            : data.time_profile_type_id === 3 && data.interval > monthly.max
                                                ? 12
                                                : Number.parseFloat(data.interval).toFixed(0)
                                    }
                                    onChange={(event) => {
                                        //validate daily
                                        if (data.time_profile_type_id === 1) {
                                            if (event.target.value > daily.max) {
                                                setData((prev) => ({ ...prev, interval: daily.max }));
                                            } else if (event.target.value < daily.min) {
                                                setData((prev) => ({ ...prev, interval: daily.min }));
                                            } else {
                                                if (event.target.value % 1 !== 0) {
                                                    setData((prev) => ({
                                                        ...prev,
                                                        interval: Math.ceil(event.target.value),
                                                    }));
                                                } else {
                                                    setData((prev) => ({ ...prev, interval: Number.parseFloat(event.target.value).toFixed(0) }));
                                                }
                                            }
                                        }

                                        //validate weekly
                                        if (data.time_profile_type_id === 2) {
                                            if (event.target.value > weekly.max) {
                                                setData((prev) => ({ ...prev, interval: weekly.max }));
                                            } else if (event.target.value < weekly.min) {
                                                setData((prev) => ({ ...prev, interval: weekly.min }));
                                            } else {
                                                if (event.target.value % 1 !== 0) {
                                                    setData((prev) => ({
                                                        ...prev,
                                                        interval: Math.ceil(event.target.value),
                                                    }));
                                                } else setData((prev) => ({ ...prev, interval: Math.ceil(event.target.value) }));
                                            }
                                        }

                                        //validate monthly
                                        if (data.time_profile_type_id === 3) {
                                            if (event.target.value > monthly.max) {
                                                setData((prev) => ({ ...prev, interval: monthly.max }));
                                            } else if (event.target.value < monthly.min) {
                                                setData((prev) => ({ ...prev, interval: monthly.min }));
                                            } else {
                                                if (event.target.value % 1 !== 0) {
                                                    setData((prev) => ({
                                                        ...prev,
                                                        interval: Math.ceil(event.target.value),
                                                    }));
                                                } else setData((prev) => ({ ...prev, interval: Math.ceil(event.target.value) }));
                                            }
                                        }
                                    }}
                                />
                            </Box>
                            <Box sx={{width: '49%'}}>
                                <TextFieldVMPCC
                                    id="select-period"
                                    select
                                    defaultValue={data.time_profile_type_id}
                                    size="small"
                                    onChange={(event) => {
                                        if (
                                            event.target.value === 1 &&
                                            event.target.value !== data.time_profile_type_id &&
                                            event.target.value === dataPeriod.time_profile_type_id
                                        ) {
                                            setData((prev) => ({
                                                ...prev,
                                                time_profile_type_id: event.target.value,
                                                interval: dataPeriod.interval,
                                                start_time: dataPeriod.start_time,
                                                end_time: dataPeriod.end_time,
                                                min_end_time: moment(periodTime.start).add(1, 'days')
                                            }));
                                            // dateRangeSearchRef.current.setStartDate(moment(dataPeriod.start_time));
                                            // dateRangeSearchRef.current.setEndDate(moment(dataPeriod.end_time));
                                            dateRangeSearchRef.current.setStartDate(moment(dataPeriod.end_time));
                                        } else if (
                                            event.target.value === 1 &&
                                            event.target.value !== data.time_profile_type_id
                                        ) {
                                            setData((prev) => ({
                                                ...prev,
                                                time_profile_type_id: event.target.value,
                                                interval: 1,
                                                start_time: periodTime.start,
                                                end_time: moment(periodTime.start).add(7, 'days'),
                                                min_end_time: moment(periodTime.start).add(1, 'days')
                                            }));
                                            // dateRangeSearchRef.current.setStartDate(moment(periodTime.start));
                                            // dateRangeSearchRef.current.setEndDate(moment(periodTime.start).add(7, 'days'));
                                            dateRangeSearchRef.current.setStartDate(moment(periodTime.start).add(7, 'days'));
                                        }

                                        if (
                                            event.target.value === 2 &&
                                            event.target.value !== data.time_profile_type_id &&
                                            event.target.value === dataPeriod.time_profile_type_id
                                        ) {
                                            setData((prev) => ({
                                                ...prev,
                                                time_profile_type_id: event.target.value,
                                                interval: dataPeriod.interval,
                                                start_time: dataPeriod.start_time,
                                                end_time: dataPeriod.end_time,
                                                min_end_time: moment(periodTime.start).add(1, 'w')
                                            }));
                                            // dateRangeSearchRef.current.setStartDate(moment(dataPeriod.start_time));
                                            // dateRangeSearchRef.current.setEndDate(moment(dataPeriod.end_time));
                                            dateRangeSearchRef.current.setStartDate(moment(dataPeriod.end_time));
                                            setSelectedDay(dataPeriod.day);
                                        } else if (
                                            event.target.value === 2 &&
                                            event.target.value !== data.time_profile_type_id
                                        ) {
                                            setData((prev) => ({
                                                ...prev,
                                                time_profile_type_id: event.target.value,
                                                interval: 1,
                                                start_time: periodTime.start,
                                                end_time: moment(periodTime.start).add(4, 'w'),
                                                min_end_time: moment(periodTime.start).add(1, 'w')
                                            }));
                                            // dateRangeSearchRef.current.setStartDate(moment(periodTime.start));
                                            // dateRangeSearchRef.current.setEndDate(moment(periodTime.start).add(4, 'w'));
                                            dateRangeSearchRef.current.setStartDate(moment(periodTime.start).add(4, 'w'));
                                            let selectedDayWeek = moment(periodTime.start).day();
                                            setSelectedDay([selectedDayWeek]);
                                        }

                                        if (
                                            event.target.value === 3 &&
                                            event.target.value !== data.time_profile_type_id &&
                                            event.target.value === dataPeriod.time_profile_type_id
                                        ) {
                                            setData((prev) => ({
                                                ...prev,
                                                time_profile_type_id: event.target.value,
                                                interval: dataPeriod.interval,
                                                start_time: dataPeriod.start_time,
                                                end_time: dataPeriod.end_time,
                                                min_end_time: moment(periodTime.start).add(1, 'M')
                                            }));
                                            // dateRangeSearchRef.current.setStartDate(moment(dataPeriod.start_time));
                                            // dateRangeSearchRef.current.setEndDate(moment(dataPeriod.end_time));
                                            dateRangeSearchRef.current.setStartDate(moment(dataPeriod.end_time));
                                            if (dataPeriod.week !== null) {
                                                setValueMonth(2);
                                                setSelectedDayWeekMonth(dataPeriod.day);
                                                setSelectedWeek(dataPeriod.week);
                                                setSelectedDayMonth([parseInt(moment(periodTime.start).format('DD'))]);
                                            } else {
                                                setValueMonth(1);
                                                // setStartDate(new Date(year, month, dataPeriod?.day[0]))
                                                setSelectedDayMonth(dataPeriod.day);
                                                setSelectedDayWeekMonth([1]);
                                                setSelectedWeek(1);
                                            }
                                        } else if (
                                            event.target.value === 3 &&
                                            event.target.value !== data.time_profile_type_id
                                        ) {
                                            setData((prev) => ({
                                                ...prev,
                                                time_profile_type_id: event.target.value,
                                                interval: 1,
                                                start_time: periodTime.start,
                                                end_time: moment(periodTime.start).add(2, 'M'),
                                                min_end_time: moment(periodTime.start).add(1, 'M')
                                            }));
                                            // dateRangeSearchRef.current.setStartDate(moment(periodTime.start));
                                            dateRangeSearchRef.current.setStartDate(moment(periodTime.start).add(2, 'M'));
                                            setValueMonth(1);
                                            // dateRangeSearchRef.current.setEndDate(moment(periodTime.start).add(2, 'M'));
                                            // setStartDate(new Date(year, month, parseInt(moment(periodTime.start).format('DD'))))
                                            setSelectedDayMonth([parseInt(moment(periodTime.start).format('DD'))]);
                                            setSelectedDayWeekMonth([1]);
                                            setSelectedWeek(1);
                                        }
                                    }}
                                >
                                    {repeat.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextFieldVMPCC>
                            </Box>
                        </div>
                    </div>
                    {data.time_profile_type_id === 2 ? (
                        <div>
                            <div className="row margin-top-row" style={{display: 'flex'}}>
                                <div className="col-md-5" style={{flex: '0 0 auto', width: '33.33333333%'}}></div>
                                <div className="col-md-7" style={{display: 'flex' ,flex: '1 0 auto', justifyContent: 'space-between', width: '66.66666667%%', paddingLeft: '24px'}}>
                                    {days.map((day, index) => {
                                        return (
                                            <TooltipCC title={t(`room.desc-week.days-tooltip.${day.value}`)}>
                                                <button
                                                    key={index}
                                                    style={{cursor: 'pointer'}}
                                                    className={
                                                        selectedDay?.includes(day.value)
                                                            ? 'button-select-day-selected'
                                                            : 'button-select-day'
                                                    }
                                                    onClick={() => {
                                                        if (selectedDay?.includes(day.value)) {
                                                            setSelectedDay(
                                                                selectedDay.filter((selected) => selected !== day.value),
                                                            );
                                                        } else {
                                                            setSelectedDay((prev) => {
                                                                if (prev) {
                                                                    return [...prev, day.value].sort((a, b) => {
                                                                        return a - b;
                                                                    });
                                                                } else {
                                                                    return [day.value];
                                                                }
                                                            });
                                                        }
                                                    }}
                                                >
                                                    {day.name}
                                                </button>
                                            </TooltipCC>
                                        );
                                    })}
                                </div>
                            </div>
                            {selectedDay.length === 0 ? (
                                <div className="row margin-top-row">
                                    <div className="col-md-5"></div>
                                    <div className="col-md-7">{t('room.model-period.desc1')}</div>
                                </div>
                            ) : (
                                <div></div>
                            )}
                        </div>
                    ) : (
                        <div></div>
                    )}
                    {data.time_profile_type_id === 3 ? (
                        <div>
                            <div className="row margin-top-row" style={{display: 'flex'}}>
                                <div className="col-md-4" style={{ display: 'flex', alignItems: 'center', flex: '0 0 auto', width: '33.33333333%'}}>
                                    <Radio
                                        checked={valueMonth === 1}
                                        onClick={(event) => {
                                            handleChangeValueMonth(1)
                                        }}
                                        value={1}
                                        name="radio-buttons"
                                        size="small"
                                    />
                                    <div style={{ cursor: 'pointer' , color: color.default}} onClick={() => handleChangeValueMonth(1)}>
                                        {t('room.model-period.title2')}
                                    </div>
                                </div>
                                <div className="col-md-8" style={{display: 'flex' ,flex: '1 0 auto', width: '66.66666667%%', paddingLeft: '24px'}}>
                                    <DatePickerCustom
                                        selectedDayMonth={selectedDayMonth}
                                        setSelectedDayMonth={setSelectedDayMonth}
                                        t={t}
                                        valueMonth={valueMonth}
                                    />
                                </div>
                            </div>
                            {(selectedDayMonth[0] === 29 || selectedDayMonth[0] === 30 || selectedDayMonth[0] === 31) &&
                                valueMonth === 1 ? (
                                <div className="row " style={{ marginTop: '5px' }}>
                                    <div className="col-md-5"></div>
                                    <div className="col-md-6">{t('room.desc-monthly.text7')}</div>
                                </div>
                            ) : (
                                <div></div>
                            )}
                            <div className="row margin-top-row" style={{display: 'flex'}}>
                                <div className="col-md-4" style={{ display: 'flex', alignItems: 'center', flex: '0 0 auto', width: '33.33333333%'}}>
                                    <Radio
                                        checked={valueMonth === 2}
                                        onClick={(event) => handleChangeValueMonth(2)}
                                        value={2}
                                        name="radio-buttons"
                                        size="small"
                                    />
                                    <div style={{ cursor: 'pointer', color: color.default}} onClick={() => handleChangeValueMonth(2)}>
                                        {t('room.model-period.title3')}
                                    </div>
                                </div>
                                <div className="col-md-8" style={{ display: 'flex', justifyContent: 'space-between',flex: '1 0 auto', width: '66.66666667%%', paddingLeft: '24px'}}>
                                    <Select
                                        style={{ width: '49%', maxHeight: '35px'}}
                                        disabled={valueMonth === 1 ? true : false}
                                        value={selectedDayWeekMonth[0]}
                                        onChange={(event) => setSelectedDayWeekMonth([event.target.value])}
                                        size='small'
                                    >
                                        <MenuItem value={1}>{t('room.model-period.monday')}</MenuItem>
                                        <MenuItem value={2}>{t('room.model-period.tuesday')}</MenuItem>
                                        <MenuItem value={3}>{t('room.model-period.wednesday')}</MenuItem>
                                        <MenuItem value={4}>{t('room.model-period.thursday')}</MenuItem>
                                        <MenuItem value={5}>{t('room.model-period.friday')}</MenuItem>
                                        <MenuItem value={6}>{t('room.model-period.saturday')}</MenuItem>
                                        <MenuItem value={7}>{t('room.model-period.sunday')}</MenuItem>
                                    </Select>
                                    <Select
                                        style={{ width: '49%', maxHeight: '35px' }}
                                        disabled={valueMonth === 1 ? true : false}
                                        value={selectedWeek}
                                        onChange={(event) => setSelectedWeek(event.target.value)}
                                        size='small'
                                    >
                                        <MenuItem value={1}>{t('room.model-period.first')}</MenuItem>
                                        <MenuItem value={2}>{t('room.model-period.second')}</MenuItem>
                                        <MenuItem value={3}>{t('room.model-period.third')}</MenuItem>
                                        <MenuItem value={4}>{t('room.model-period.fourth')}</MenuItem>
                                        <MenuItem value={5}>{t('room.model-period.fifth')}</MenuItem>
                                    </Select>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div></div>
                    )}
                    <div className="row margin-top-row">
                        {data.time_profile_type_id === 1 ? (
                            <em  className="col-md-12 note-description">
                                {t('room.desc-day.text1')}{' '}
                                {data.interval === 1
                                    ? t('room.desc-day.text2')
                                    : `${t('room.desc-day.text5')} ${data.interval} ${t('room.desc-day.text3')}`}{' '}
                                {t('room.desc-day.text6')} {moment(data.start_time).format('DD/MM/YYYY')}{' '}
                                {t('room.desc-day.text4')} {moment(data.end_time).format('DD/MM/YYYY')}
                            </em>
                        ) : (
                            <div></div>
                        )}
                        {data.time_profile_type_id === 2 ? (
                            selectedDay?.length === 1 ? (
                                <em className="col-md-12 note-description">
                                    {t('room.desc-week.text1')} {ChangeDay(selectedDay[0], t)}{' '}
                                    {data.interval === 1
                                        ? t('room.desc-week.text2')
                                        : `${t('room.desc-week.text7')} ${data.interval} ${t(
                                            'room.desc-week.text3',
                                        )}`}
                                    {' '}
                                    {t('room.desc-week.text8')} {moment(data.start_time).format('DD/MM/YYYY')}
                                    {' '}
                                    {t('room.desc-week.text4')} {moment(data.end_time).format('DD/MM/YYYY')}
                                </em>
                            ) : (
                                <div></div>
                            )
                        ) : (
                            <div></div>
                        )}
                        {data.time_profile_type_id === 2 ? (
                            selectedDay?.length === 2 ? (
                                <em className="col-md-12 note-description">
                                    {t('room.desc-week.text1')} {ChangeDay(selectedDay[0], t)} {t('room.desc-week.and')}{' '}
                                    {ChangeDay(selectedDay[1], t)}{' '}
                                    {data.interval === 1
                                        ? t('room.desc-week.text2')
                                        : `${t('room.desc-week.text7')} ${data.interval} ${t(
                                            'room.desc-week.text3',
                                        )}`}
                                    {' '}
                                    {t('room.desc-week.text8')} {moment(data.start_time).format('DD/MM/YYYY')}
                                    {' '}
                                    {t('room.desc-week.text4')} {moment(data.end_time).format('DD/MM/YYYY')}
                                </em>
                            ) : (
                                <div></div>
                            )
                        ) : (
                            <div></div>
                        )}
                        {data.time_profile_type_id === 2 ? (
                            selectedDay?.length === 3 ? (
                                <em className="col-md-12 note-description">
                                    {t('room.desc-week.text1')} {ChangeDay(selectedDay[0], t)},{' '}
                                    {ChangeDay(selectedDay[1], t)} {t('room.desc-week.and')}{' '}
                                    {ChangeDay(selectedDay[2], t)}{' '}
                                    {data.interval === 1
                                        ? t('room.desc-week.text2')
                                        : `${t('room.desc-week.text7')} ${data.interval} ${t(
                                            'room.desc-week.text3',
                                        )}`}
                                    {' '}
                                    {t('room.desc-week.text8')} {moment(data.start_time).format('DD/MM/YYYY')}
                                    {' '}
                                    {t('room.desc-week.text4')} {moment(data.end_time).format('DD/MM/YYYY')}
                                </em>
                            ) : (
                                <div></div>
                            )
                        ) : (
                            <div></div>
                        )}
                        {data.time_profile_type_id === 2 ? (
                            selectedDay?.length === 4 ? (
                                <em className="col-md-12 note-description">
                                    {t('room.desc-week.text1')} {ChangeDay(selectedDay[0], t)},{' '}
                                    {ChangeDay(selectedDay[1], t)}, {ChangeDay(selectedDay[2], t)}{' '}
                                    {t('room.desc-week.and')} {ChangeDay(selectedDay[3], t)}{' '}
                                    {data.interval === 1
                                        ? t('room.desc-week.text2')
                                        : `${t('room.desc-week.text7')} ${data.interval} ${t(
                                            'room.desc-week.text3',
                                        )}`}
                                    {' '}
                                    {t('room.desc-week.text8')} {moment(data.start_time).format('DD/MM/YYYY')}
                                    {' '}
                                    {t('room.desc-week.text4')} {moment(data.end_time).format('DD/MM/YYYY')}
                                </em>
                            ) : (
                                <div></div>
                            )
                        ) : (
                            <div></div>
                        )}
                        {data.time_profile_type_id === 2 ? (
                            selectedDay?.length === 5 ? (
                                <em className="col-md-12 note-description">
                                    {t('room.desc-week.text1')} {ChangeDay(selectedDay[0], t)},{' '}
                                    {ChangeDay(selectedDay[1], t)}, {ChangeDay(selectedDay[2], t)},{' '}
                                    {ChangeDay(selectedDay[3], t)} {t('room.desc-week.and')}{' '}
                                    {ChangeDay(selectedDay[4], t)}{' '}
                                    {data.interval === 1
                                        ? t('room.desc-week.text2')
                                        : `${t('room.desc-week.text7')} ${data.interval} ${t(
                                            'room.desc-week.text3',
                                        )}`}
                                    {' '}
                                    {t('room.desc-week.text8')} {moment(data.start_time).format('DD/MM/YYYY')}
                                    {' '}
                                    {t('room.desc-week.text4')} {moment(data.end_time).format('DD/MM/YYYY')}
                                </em>
                            ) : (
                                <div></div>
                            )
                        ) : (
                            <div></div>
                        )}
                        {data.time_profile_type_id === 2 ? (
                            selectedDay?.length === 6 ? (
                                <em className="col-md-12 note-description">
                                    {t('room.desc-week.text1')} {ChangeDay(selectedDay[0], t)},{' '}
                                    {ChangeDay(selectedDay[1], t)}, {ChangeDay(selectedDay[2], t)},{' '}
                                    {ChangeDay(selectedDay[3], t)}, {ChangeDay(selectedDay[4], t)}{' '}
                                    {t('room.desc-week.and')} {ChangeDay(selectedDay[5], t)}{' '}
                                    {data.interval === 1
                                        ? t('room.desc-week.text2')
                                        : `${t('room.desc-week.text7')} ${data.interval} ${t(
                                            'room.desc-week.text3',
                                        )}`}
                                    {' '}
                                    {t('room.desc-week.text8')} {moment(data.start_time).format('DD/MM/YYYY')}
                                    {' '}
                                    {t('room.desc-week.text4')} {moment(data.end_time).format('DD/MM/YYYY')}
                                </em>
                            ) : (
                                <div></div>
                            )
                        ) : (
                            <div></div>
                        )}
                        {data.time_profile_type_id === 2 ? (
                            selectedDay?.length === 7 ? (
                                <em className="col-md-12 note-description">
                                    {t('room.desc-week.text1')} {ChangeDay(selectedDay[0], t)},{' '}
                                    {ChangeDay(selectedDay[1], t)}, {ChangeDay(selectedDay[2], t)},{' '}
                                    {ChangeDay(selectedDay[3], t)}, {ChangeDay(selectedDay[4], t)},{' '}
                                    {ChangeDay(selectedDay[5], t)} {t('room.desc-week.and')}{' '}
                                    {ChangeDay(selectedDay[6], t)}{' '}
                                    {data.interval === 1
                                        ? t('room.desc-week.text2')
                                        : `${t('room.desc-week.text7')} ${data.interval} ${t(
                                            'room.desc-week.text3',
                                        )}`}
                                    {' '}
                                    {t('room.desc-week.text8')} {moment(data.start_time).format('DD/MM/YYYY')}
                                    {' '}
                                    {t('room.desc-week.text4')} {moment(data.end_time).format('DD/MM/YYYY')}
                                </em>
                            ) : (
                                <div></div>
                            )
                        ) : (
                            <div></div>
                        )}
                        {data.time_profile_type_id === 3 ? (
                            valueMonth === 1 ? (
                                <em className="col-md-12 note-description">
                                    {t('room.desc-monthly.text1')}{' '}
                                    {selectedDayMonth[0] === 32 ? t('room.desc-monthly.text6') : selectedDayMonth[0]}{' '}
                                    {data.interval === 1
                                        ? t('room.desc-monthly.text2')
                                        : `${t('room.desc-monthly.text8')} ${data.interval} ${t(
                                            'room.desc-monthly.text3',
                                        )}`}
                                    {' '}
                                    {t('room.desc-monthly.text9')} {moment(data.start_time).format('DD/MM/YYYY')}
                                    {' '}
                                    {t('room.desc-monthly.text4')} {moment(data.end_time).format('DD/MM/YYYY')}
                                </em>
                            ) : (
                                <div></div>
                            )
                        ) : (
                            <div></div>
                        )}
                        {data.time_profile_type_id === 3 ? (
                            valueMonth === 2 ? (
                                <em className="col-md-12 note-description">
                                    {t('room.desc-monthly.text1-1')} {ChangeDay(selectedDayWeekMonth, t)}{' '}
                                    {t('room.desc-monthly.text5')} {ChangeWeek(selectedWeek - 1, t, true)}{' '}
                                    {data.interval === 1
                                        ? t('room.desc-monthly.text2')
                                        : `${t('room.desc-monthly.text8')} ${data.interval} ${t(
                                            'room.desc-monthly.text3',
                                        )}`}
                                    {' '}
                                    {t('room.desc-monthly.text9')} {moment(data.start_time).format('DD/MM/YYYY')}
                                    {' '}
                                    {t('room.desc-monthly.text4')} {moment(data.end_time).format('DD/MM/YYYY')}
                                </em>
                            ) : (
                                <div></div>
                            )
                        ) : (
                            <div></div>
                        )}
                    </div>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'end' }}>
                    {/* <ThemeProvider theme={theme}> */}
                    <Button 
                    variant='outlined' 
                    onClick={() => {
                        setIsClosed(!isClosed);
                        handleClose();
                    }}
                    >
                        {t('room.cancel')}
                    </Button>
                    <Button 
                        variant='contained' 
                        onClick={handleSubmit}
                        disabled={selectedDay.length === 0 && data.time_profile_type_id === 2 ? true : false}
                    >
                        {t('room.save')}
                    </Button>
                    {/* </ThemeProvider> */}
                </DialogActions>
            </Dialog>
        </div>
    );
}
